import { Component, OnInit } from '@angular/core';
import { RelationshipManager } from '../shared/models/relationship-manager.model';
import { CompanyService } from '../shared/services/company.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'contact-us',
  styleUrls: ['./contact-us.component.scss'],
  templateUrl: './contact-us.component.html'
})
export class ContactUsComponent implements OnInit {
  relationshipManagers: Array<RelationshipManager>;

  constructor(private companyService: CompanyService, private titleService: Title) {
    this.titleService.setTitle('Arvest Business Partner Portal: Contact Us');
  }

  ngOnInit() {
    this.companyService.getRelationshipManagers().then(res => this.relationshipManagers = res);
  }

}
